import { MerchantProcessorDto } from "@merchant_api/models/merchant-processor-dto";

export class MidsState {
    loading = false;
    error = null;
    record: Array<MerchantProcessorDto> = [];
}
